/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface LocationUsageRow
 */
export interface LocationUsageRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LocationUsageRow
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof LocationUsageRow
     */
    locationName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LocationUsageRow
     */
    classesCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the LocationUsageRow interface.
 */
export function instanceOfLocationUsageRow(value: object): value is LocationUsageRow {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('classesCount' in value) || value['classesCount'] === undefined) return false;
    return true;
}

export function LocationUsageRowFromJSON(json: any): LocationUsageRow {
    return LocationUsageRowFromJSONTyped(json, false);
}

export function LocationUsageRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationUsageRow {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'classesCount': ApiUserTasksGetPageParameterFromJSON(json['classesCount']),
    };
}

export function LocationUsageRowToJSON(json: any): LocationUsageRow {
    return LocationUsageRowToJSONTyped(json, false);
}

export function LocationUsageRowToJSONTyped(value?: LocationUsageRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'locationName': value['locationName'],
        'classesCount': ApiUserTasksGetPageParameterToJSON(value['classesCount']),
    };
}

